function isTouchDevice() {
    return ('ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        ((navigator === null || navigator === void 0 ? void 0 : navigator.msMaxTouchPoints) || 0) > 0);
}

export { isTouchDevice as default, isTouchDevice };
